import { ArrowDown2Icon, FaroText, grey } from "@faro-lotv/flat-ui";
import Accordion, { AccordionProps } from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Stack } from "@mui/system";
import { PropsWithChildren, type JSX } from "react";

type DebugOverlaySectionProps = Pick<AccordionProps, "defaultExpanded"> &
  PropsWithChildren<{
    title: string;
  }>;

/** @returns a single section included in the rendering debug overlay. */
export function DebugOverlaySection({
  title,
  children,
  ...accordionProps
}: DebugOverlaySectionProps): JSX.Element {
  return (
    <Accordion
      sx={{
        background: "transparent",
        boxShadow: "none",
        "&::before": {
          // Divider color
          backgroundColor: grey[300],
        },
      }}
      {...accordionProps}
    >
      <AccordionSummary
        expandIcon={
          <FaroText variant="heading12" dark>
            <ArrowDown2Icon />
          </FaroText>
        }
        sx={{
          py: 1,
          "&, &.Mui-expanded": {
            minHeight: "unset",
          },
          "& .MuiAccordionSummary-content, & .Mui-expanded .MuiAccordionSummary-content":
            {
              my: 1,
            },
        }}
      >
        <FaroText dark variant="heading12">
          {title}
        </FaroText>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          px: 2,
          py: 1,
          "&.Mui-expanded": {
            m: 0,
          },
        }}
      >
        <Stack sx={{ gap: 1 }}>{children}</Stack>
      </AccordionDetails>
    </Accordion>
  );
}
